import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "menu-container" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "submenu"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

import { ref, computed, onMounted, onUnmounted } from "vue";
import { EyeIcon, ArrowDownTrayIcon, StarIcon as StarIconSolid } from "@heroicons/vue/24/solid";
import { StarIcon as StarIconOutline } from "@heroicons/vue/24/outline";
import { useReportsStore } from "@/store/store/reportsStore";
import type { ReportItem, ReportExportFormat } from "@/types/reports";

const MENU_WIDTH = 160;
const MENU_HEIGHT = 180;


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportRowMenu',
  props: {
    report: {}
  },
  emits: ["view", "toggle-favorite", "download"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const reportsStore = useReportsStore();
const isFavorite = computed(() => reportsStore.favoriteIds.has(props.report.id));
const isDownloading = computed(() => reportsStore.downloadingId === props.report.id);

const emit = __emit;

const open = ref(false);
const showFormats = ref(false);
const downloadingFormat = ref<ReportExportFormat | null>(null);
const contextX = ref<number | null>(null);
const contextY = ref<number | null>(null);

const dropdownStyle = computed(() => {
  if (contextX.value === null) return {};
  const x = Math.min(contextX.value, window.innerWidth - MENU_WIDTH - 8);
  const y = Math.min(contextY.value!, window.innerHeight - MENU_HEIGHT - 8);
  return {
    position: "fixed" as const,
    left: `${x}px`,
    top: `${y}px`,
    right: "auto",
  };
});

function closeMenu() {
  open.value = false;
  showFormats.value = false;
  contextX.value = null;
  contextY.value = null;
}

function openAt(x: number, y: number) {
  contextX.value = x;
  contextY.value = y;
  open.value = true;
}

function triggerDownload(format: ReportExportFormat) {
  downloadingFormat.value = format;
  emit("download", format);
  closeMenu();
}

__expose({ openAt });

onMounted(() => document.addEventListener("click", closeMenu));
onUnmounted(() => document.removeEventListener("click", closeMenu));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["kebab-btn", { active: open.value }]),
      "aria-label": "Report options",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (open.value = !open.value), ["stop"]))
    }, " ⋮ ", 2),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dropdown-menu",
          style: _normalizeStyle(dropdownStyle.value),
          onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "dropdown-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {emit('view'); closeMenu()})
          }, [
            _createVNode(_unref(EyeIcon), { class: "item-icon" }),
            _cache[9] || (_cache[9] = _createTextVNode(" View ", -1))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "dropdown-item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {emit('toggle-favorite'); closeMenu()})
          }, [
            (isFavorite.value)
              ? (_openBlock(), _createBlock(_unref(StarIconSolid), {
                  key: 0,
                  class: "item-icon item-icon--star"
                }))
              : (_openBlock(), _createBlock(_unref(StarIconOutline), {
                  key: 1,
                  class: "item-icon item-icon--star"
                })),
            _createTextVNode(" " + _toDisplayString(isFavorite.value ? "Unfavorite" : "Favorite"), 1)
          ]),
          (!__props.report.isPaginated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["dropdown-item", { 'dropdown-item--disabled': isDownloading.value }]),
                disabled: isDownloading.value,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (triggerDownload('pdf')))
              }, [
                _createVNode(_unref(ArrowDownTrayIcon), { class: "item-icon" }),
                _createTextVNode(" " + _toDisplayString(isDownloading.value ? "Downloading…" : "Download"), 1)
              ], 10, _hoisted_2))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "dropdown-item dropdown-item--submenu-toggle",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showFormats.value = !showFormats.value), ["stop"]))
                }, [
                  _createVNode(_unref(ArrowDownTrayIcon), { class: "item-icon" }),
                  _cache[10] || (_cache[10] = _createTextVNode(" Download ", -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(["submenu-chevron", { open: showFormats.value }])
                  }, "▶", 2)
                ]),
                (showFormats.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["dropdown-item dropdown-item--sub", { 'dropdown-item--disabled': isDownloading.value }]),
                        disabled: isDownloading.value,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (triggerDownload('pdf')))
                      }, _toDisplayString(isDownloading.value && downloadingFormat.value === 'pdf' ? "Downloading…" : "PDF"), 11, _hoisted_4),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["dropdown-item dropdown-item--sub", { 'dropdown-item--disabled': isDownloading.value }]),
                        disabled: isDownloading.value,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (triggerDownload('xlsx')))
                      }, _toDisplayString(isDownloading.value && downloadingFormat.value === 'xlsx' ? "Downloading…" : "Excel"), 11, _hoisted_5),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["dropdown-item dropdown-item--sub", { 'dropdown-item--disabled': isDownloading.value }]),
                        disabled: isDownloading.value,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (triggerDownload('csv')))
                      }, _toDisplayString(isDownloading.value && downloadingFormat.value === 'csv' ? "Downloading…" : "CSV"), 11, _hoisted_6)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})